export default "__VITE_ASSET__CMvdzCu4__"